module.exports = __webpack_public_path__ + "static/media/MinionPro-Regular.38711b5b.otf";